import { PropsWithChildren } from "react"

export default function SocialIconButton({
    href,
    className,
    ariaLabel,
    inverted,
    children,
}: PropsWithChildren & {
    href: string
    className?: string
    ariaLabel?: string
    inverted?: boolean
}) {
    return (
        <div
            className={`
                rounded-full transition-all duration-100

                ${
                    inverted
                        ? `
                            border border-bonza-dark bg-bonza-pale
                            text-bonza-dark

                            hover:bg-bonza-dark hover:text-bonza-pale
                        `
                        : `
                            bg-bonza-dark-bg text-bonza-pale

                            hover:bg-bonza-pale hover:text-bonza-dark
                        `
                }
                ${className}
            `}
        >
            <a
                href={href}
                className={"h-full w-full"}
                target={"_blank"}
                rel="noreferrer"
                aria-label={ariaLabel}
            >
                <div className={"p-4"}>{children}</div>
            </a>
        </div>
    )
}
